import { h } from "preact";

import "./NowPlaying.scss";
import { forwardRef, useMemo, useState } from "preact/compat";
import useNowPlaying from "../../lib/useNowPlaying";

const NowPlaying = forwardRef<HTMLDivElement>((props, ref) => {
    const [trackNow, trackData] = useNowPlaying();

    if (trackData) {
        const track = trackData.nowPlaying.track;
        return (
            <div class={"now-playing" + (trackNow ? " playing" : " not-playing")}>
                <img alt="URY Record" src="https://ury.org.uk/images/URYRecord.png" />
                <div class="meta">
                    <span class="label">{trackNow ? "Now Playing" : "Last Played"}</span>
                    <span class="title">{track.title}</span>
                    <span class="artist">{track.artist}</span>
                </div>
            </div>
        );
    }

    return null;

});

export default NowPlaying;
